module.exports = __webpack_public_path__ + "assets/video/maximus.mp4";